module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r9r2r5r-b5c7080ebe1feb9180265b7ca75e7367.svg";